import { DependencyList, useEffect, useState } from 'react'
import { useStatus } from '../../../__legacy__/components/core/Utils'

export const useAsyncMemo = <T,>(
  factory: () => Promise<T | undefined | null>,
  deps: DependencyList,
  initial?: T
) => {
  const [status, setStatus] = useStatus()
  const [value, setValue] = useState<T | undefined>(initial)
  useEffect(() => {
    setStatus('loading')
    let cancel = false
    const promise = factory()
    if (promise === undefined || promise === null) {
      setStatus('error')
      return
    }
    promise.then((val) => {
      if (!cancel) {
        setValue(val)
        setStatus('ready')
      }
      setStatus('loading')
    })
    return () => {
      cancel = true
    }
  }, deps)
  return { status, value }
}
